export function useOCR() {
  return [() => {}, null];
}
